import { Trans } from '@lingui/macro';

import { TTrip } from '../../../domains/trips/trip';
import { getNameLocal } from '../../../lib/local/get-title';
import { useLocal } from '../../../lib/local/use-local';

import styles from './trip-data.module.css';

type TripDataProps = {
  trip?: TTrip;
};

export const TripData = ({ trip }: TripDataProps) => {
  const [lang] = useLocal();

  if (!trip) return null;

  return (
    <>
      <dl className={styles.root}>
        <div>
          <dt className={styles.listKey}>
            <Trans>Номер рейса</Trans>
          </dt>
          <dd className={styles.listValue}>{trip.route.number}</dd>
        </div>

        <div className={styles.rightColumn}>
          <dt className={styles.listKey}>
            <Trans>Тип состава</Trans>
          </dt>
          <dd className={styles.listValue}>
            {getNameLocal(lang, trip.trainType)}
          </dd>
        </div>
      </dl>
    </>
  );
};
